'use strict';

angular.module('app.print.header')
    .directive('printHeaderDirective', function () {
        return {
            controller: 'PrintHeaderCtrl',
            templateUrl: 'app/printHeader/printHeader.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                titleType: "=",
                pageBreak: "=",
                pageShown: "=",
                pageNo: "="
            },
            replace: true,
            transclude: true
        };
    })